import * as React from "react";
import { useCallback } from "react";
import { isNil } from "ramda";

import { Field, FieldLabel, ValidationError } from "affinityUI/form/components";
import { Input } from "affinityUI/form/inputs/input";

import { useAffinityField } from "../../helpers";

export const InputField: React.FC<
  React.ComponentProps<typeof Input> & { updateValue?: (nextValue: string, prevValue: string) => string }
> = ({ children, updateValue, disabled, ...props }) => {
  const { name } = props;
  const [{ onChange, ...fieldData }, meta, { setValue }] = useAffinityField(name);
  const handleUpdateValue = useCallback(
    (e) => {
      if (!isNil(updateValue)) {
        setValue(updateValue(e.target.value, fieldData.value ?? ""));
      }
    },
    [fieldData.value, setValue, updateValue]
  );
  const handleChange = isNil(updateValue) ? onChange : handleUpdateValue;
  const field = { ...fieldData, value: fieldData.value ?? "" };
  return (
    <Field>
      <FieldLabel id={`field-${name}`} htmlFor={name}>
        {children}
      </FieldLabel>
      <Input
        id={name}
        onChange={handleChange}
        $error={meta?.error}
        {...field}
        autoComplete="off"
        disabled={disabled}
        {...props}
      />
      {meta?.error && <ValidationError>{meta?.error}</ValidationError>}
    </Field>
  );
};
